import info from 'assets/images/mask.png'

export  const backgroundHeader = () => info
 
